import { privacyPolicy } from "@serophin/shared";
import { NOTTLDR_LEGAL } from "./app";
import { PRIVACY_COLLECTED, PRIVACY_INTRO, PRIVACY_USE } from "./privacyCollected";
import {
  PRIVACY_AI,
  PRIVACY_INTERNATIONAL,
  PRIVACY_PROCESSORS,
  PRIVACY_RETENTION,
  PRIVACY_RIGHTS,
  PRIVACY_SECURITY_AND_CHILDREN,
  PRIVACY_SHARING,
} from "./privacyHandling";

export const NOTTLDR_PRIVACY = privacyPolicy(NOTTLDR_LEGAL, {
  title: "Privacy Policy",
  responsible: PRIVACY_INTRO,
  collected: PRIVACY_COLLECTED,
  sections: [PRIVACY_USE],
  payments: ["Tips are optional and paid through Stripe Checkout. Your card details go to Stripe, not to us, and we keep no record of a tip on your account."],
  processors: PRIVACY_PROCESSORS,
  handling: [PRIVACY_SHARING, PRIVACY_AI, PRIVACY_INTERNATIONAL],
  retention: PRIVACY_RETENTION,
  rights: PRIVACY_RIGHTS,
  more: PRIVACY_SECURITY_AND_CHILDREN,
  changes:
    "We may update this Privacy Policy occasionally to reflect changes in our practices or legal requirements. We'll notify you of significant changes via email or a prominent notice on our platform. Continued use after changes indicates acceptance of the updated policy.",
  closing: ["At Serophin, we're committed to respecting your privacy. Your trust matters to us."],
});
